if (!customElements.get('responsive-tabs')) {
  customElements.define(
    'responsive-tabs',
    class ResponsiveTabs extends HTMLElement {
      constructor() {
        super();

        this.activeTab = this.activeTab.bind(this);

        const tabs = this.querySelectorAll('nav a');

        if (tabs) {
          tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
              e.preventDefault();
              this.activeTab(tab.getAttribute('href').substring(1));
            });
          });
        }

        const buttons = this.querySelectorAll('button[aria-controls]');

        if (buttons) {
          buttons.forEach((button) => {
            button.addEventListener('click', (e) => {
              e.preventDefault();
              this.activeTab(e.target.getAttribute('aria-controls'), true);
            });
          });
        }
      }

      connectedCallback() {
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const panelId = 'panel-' + event.detail.blockId;

            if (!this.querySelector('#' + panelId)) {
              return;
            }

            this.activeTab(panelId);
          });
        }

        if (location.hash) {
          this.activeTab(location.hash.substring(1));
        }
      }

      activeTab(id, collapse = false) {
        const tab = this.querySelector('nav a[href="#' + id + '"]');
        const panel = this.querySelector('[id="' + id + '"]');

        if (!tab || !panel || tab.hasAttribute('active')) {
          return;
        }

        const currentTab = this.querySelector('nav a[active]');
        const currentPanel = currentTab
          ? this.querySelector('[id=' + currentTab.getAttribute('href').substring(1) + ']')
          : null;

        if (currentTab) {
          currentTab.removeAttribute('active');
        }

        if (currentPanel) {
          currentPanel.removeAttribute('active');
        }

        tab.setAttribute('active', '');
        panel.setAttribute('active', '');

        if (collapse) {
          slideUp(currentPanel.querySelector('.tab-panel__content'));
          slideDown(panel.querySelector('.tab-panel__content'));
        }
      }
    }
  );
}
